import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-error-forbidden',
    templateUrl: './error-forbidden.component.html',
    styleUrls: ['./error-forbidden.component.scss'],
    standalone: false
})
export class ErrorForbiddenComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
